import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestStorageListAction } from 'redux/actions/type';
import { REQUEST_STORAGE_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import {
  requestStorageListSuccess,
  requestStorageListFailure,
  throwError,
} from 'redux/actions/actions';
import { PaginationType } from 'commons/framework/type';
import StorageVO from 'commons/vo/StorageVO';
import { AxiosResponse } from 'axios';

function* requestStorageListSaga(action: RequestStorageListAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.STORAGE);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: StorageVO[] = keyFlowResponse.getResult(StorageVO) as StorageVO[];
    yield put(requestStorageListSuccess({ storageList: resultList }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStorageListFailure());
  }
}

export function* watchStorageSaga() {
  yield takeEvery(REQUEST_STORAGE_LIST, requestStorageListSaga);
}
